// sticky-logo-bar.js — Poleras Metal
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('pm-sticky-logo-bar');
    if (!bar) return;

    var lastScroll = 0;

    // Al hacer clic estando en el inicio, hace scroll suave arriba
    // en vez de recargar la página
    bar.addEventListener('click', function (e) {
      var isHome = window.location.pathname === '/' || window.location.pathname === '';
      if (isHome) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    // Oculta al bajar el scroll, muestra al subir
    window.addEventListener('scroll', function () {
      var current = window.scrollY;
      if (current > lastScroll && current > 80) {
        bar.classList.add('pm-hide');
      } else {
        bar.classList.remove('pm-hide');
      }
      lastScroll = current;
    });
  });
})();